import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faClock, faEnvelope, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import '../../styles/auth/RegistrationConfirmationPage.css';

const RegistrationConfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get data from navigation state
  const { centerName, registrationId } = location.state || {};
  
  // Redirect if no registration data
  React.useEffect(() => {
    if (!centerName || !registrationId) {
      navigate('/register', { replace: true });
    }
  }, [centerName, registrationId, navigate]);
  
  const handleBackToLogin = () => {
    // Navigate back to login screen
    navigate('/login', { replace: true });
  };
  
  return (
    <div className="registration-confirmation-container">
      <div className="confirmation-card">
        <div className="success-icon-container">
          <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
        </div>
        
        <h1 className="confirmation-title">Registration Submitted</h1>
        
        <p className="confirmation-message">
          Thank you for registering with <span className="center-name">{centerName}</span>.
          Your registration has been submitted and is pending approval.
        </p>
        
        <div className="registration-id-container">
          <p className="registration-id-label">Registration ID:</p>
          <p className="registration-id">{registrationId}</p>
        </div>
        
        <div className="info-container">
          <h2 className="info-title">What happens next?</h2>
          
          <div className="info-item">
            <FontAwesomeIcon icon={faClock} className="info-icon" />
            <p className="info-text">
              Your registration will be reviewed by the center administrator.
            </p>
          </div>
          
          <div className="info-item">
            <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
            <p className="info-text">
              You will receive an email notification once your registration is approved.
            </p>
          </div>
          
          <div className="info-item">
            <FontAwesomeIcon icon={faSignInAlt} className="info-icon" />
            <p className="info-text">
              After approval, you can log in using the email and password you provided.
            </p>
          </div>
        </div>
        
        <button
          className="back-to-login-button"
          onClick={handleBackToLogin}
        >
          Back to Login
        </button>
        
        <div className="contact-container">
          <p className="contact-text">
            If you have any questions, please contact {centerName} directly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationConfirmationPage;
